var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartLightComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1922,
    height: 820,
    viewBox: "0 0 1922 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter0_f_2128_17362)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1565.5,
    cy: 480.5,
    r: 148.5,
    fill: "#5E41CE",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2128_17362",
    x: 1177,
    y: 92,
    width: 777,
    height: 777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_2128_17362"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartLightComponents);
export default __webpack_public_path__ + "static/media/StartLightComponents.48493950ec8f8c69e1ab30f75607373b.svg";
export { ForwardRef as ReactComponent };